import $ from 'jquery'
import yaml from 'js-yaml'

const config = yaml.safeLoad(
    $.ajax({
        url: '/static/config.yaml?_t=' + new Date().getTime(),
        async: false
    }).responseText
)

window.config = config
window.pageSize = 20

export default config



// WEBPACK FOOTER //
// ./src/config.js